import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isChallengesImageChoice(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.CHALLENGES_IMAGE_CHOICE && typeof label === 'string' && Array.isArray(value) && value.every(item => typeof item === 'string');
}
function _formatChallengesImageChoice(_ref) {
  let {
    field,
    value
  } = _ref;
  if (value.length === 0) {
    return undefined;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatChallengesImageChoice(submission) {
  if (isChallengesImageChoice(submission)) {
    return _formatChallengesImageChoice(submission);
  }
  return undefined;
}
//# sourceMappingURL=challenges-image-choice-preview.js.map